import * as React from 'react';
import { KeyboardManager, KEYBOARD_CONTEXT, IKeyboardContext } from './KeyboardContext';
import { elementContains } from '@uifabric/utilities/lib/dom';

export class KeyboardZone extends React.PureComponent {
  private _keyboardManager: KeyboardManager;
  private _parentContext: KeyboardManager | undefined;
  private _div: HTMLDivElement | undefined;
  private _registerAsChild: boolean;

  constructor(props: {}) {
    super(props);
    this._keyboardManager = new KeyboardManager({ isDefault: false /* isDefault */ });
    // when keyboardZone is created, set active as default before explicitly keyboard focus is moved away.
    if (this._keyboardManager) {
      this._keyboardManager.setIsActive(true);
    }
    // parentContext is used to inform its immediate parent state since when child dialog popup and close
    // does not trig onFocus change event but KeyboardZone state should change for its parentContext.
    this._parentContext = undefined;
    this._registerAsChild = false;
  }

  public componentWillUnmount(): void {
    // when current KeyboardZone unmount, dispose its associated keyboardManager
    // also inform parent Zone that this child becomes inactive.
    if (this._keyboardManager) {
      this._keyboardManager.setIsActive(false);
      this._keyboardManager.dispose();
    }
    if (this._parentContext) {
      this._parentContext.registerActiveChild(false);
    }
  }

  public render(): JSX.Element {
    return (
      <KEYBOARD_CONTEXT.Consumer>
        { ({ keyboardManager }: IKeyboardContext) => {
          if (!this._registerAsChild) {
            keyboardManager.registerActiveChild(true);
            this._registerAsChild = true;
            this._parentContext = keyboardManager;
          }
          return (
            <div ref={ (c: HTMLDivElement) => this._div = c } onFocusCapture={ this._onFocusCapture } >
              <KEYBOARD_CONTEXT.Provider value={ { keyboardManager: this._keyboardManager } }>
                { this.props.children }
              </KEYBOARD_CONTEXT.Provider>
            </div>
          );
        } }
      </KEYBOARD_CONTEXT.Consumer>
    );
  }

  private _onFocusCapture = (): void => {
    // set the closest keyboardZone of current focused element in active state and
    // ensure all other keyboardZone manager is inactive.
    let activeElement: HTMLElement = document.activeElement as HTMLElement;
    if (!!activeElement && (this._div === activeElement || elementContains(this._div as HTMLElement, activeElement))) {
      this._keyboardManager.setIsActive(true);
    }
  }
}
